import React from "react"
import Back from "../common/Back"
import RecentCard from "../home/recent/RecentCard"
import "../home/recent/recent.css"
import img from "../images/about.jpg"
import { useLanguage } from "../../context/LanguageContext"

const Blog = () => {
  const { content } = useLanguage()
  const { blog } = content

  return (
    <>
      <section className='blog-out mb'>
        <Back name={blog.backName} title={blog.backTitle} cover={img} />
        <div className='container recent'>
          <RecentCard />
        </div>
      </section>
    </>
  )
}

export default Blog
